// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "groupfolders-" + chunkId + ".js?v=" + {"vendors-node_modules_nextcloud_axios_dist_index_esm_js-node_modules_nextcloud_vue_dist_Compon-cb985d":"7bc8381d503a349d2df6","sharing":"6b17c9b212331ffd4e3b"}[chunkId] + "";
};